var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNeokredLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 131,
    height: 34,
    viewBox: "0 0 131 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.9192 5.63135V21.2115L29.5711 13.0378V21.2646H26.278V5.71397L35.5789 13.9349V5.63135H38.9192Z",
    fill: "#38369C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M53.6141 18.3787V21.2646H42.1473V5.63135H53.6141V8.51131H45.4404V12.0109H51.4895V14.8319H45.4404V18.3728H53.6141V18.3787Z",
    fill: "#38369C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M62.5727 21.483C61.5212 21.4905 60.4797 21.2774 59.5157 20.8574C58.5801 20.4517 57.7308 19.8707 57.0134 19.1459C55.5299 17.6391 54.7025 15.6067 54.7118 13.4922C54.7041 11.3797 55.5313 9.34978 57.0134 7.84442C57.7308 7.11961 58.5801 6.53869 59.5157 6.13297C60.482 5.72031 61.5219 5.50757 62.5727 5.50757C63.6235 5.50757 64.6634 5.72031 65.6297 6.13297C66.5645 6.5402 67.4135 7.12094 68.132 7.84442C69.6141 9.34978 70.4413 11.3797 70.4336 13.4922C70.4429 15.6067 69.6155 17.6391 68.132 19.1459C67.4135 19.8694 66.5645 20.4502 65.6297 20.8574C64.6657 21.2774 63.6242 21.4905 62.5727 21.483ZM62.5727 8.80048C61.9632 8.7944 61.3594 8.91917 60.8022 9.16638C60.265 9.4066 59.7799 9.7494 59.374 10.1755C58.9607 10.6127 58.6325 11.123 58.4062 11.6804C57.934 12.8483 57.934 14.1539 58.4062 15.3217C58.6342 15.873 58.9623 16.3772 59.374 16.8089C59.778 17.2387 60.2635 17.5838 60.8022 17.824C61.355 18.0654 61.9518 18.1901 62.555 18.1901C63.1582 18.1901 63.755 18.0654 64.3078 17.824C64.8456 17.5823 65.3308 17.2374 65.7359 16.8089C66.1457 16.3757 66.4736 15.8718 66.7038 15.3217C67.176 14.1539 67.176 12.8483 66.7038 11.6804C66.4752 11.1242 66.1473 10.6142 65.7359 10.1755C65.329 9.75065 64.8442 9.40804 64.3078 9.16638C63.7615 8.92409 63.1703 8.79942 62.5727 8.80048Z",
    fill: "#38369C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M78.9908 13.4745L85.4825 21.2646H81.5403L77.0374 15.8175L75.5325 17.6351V21.2646H72.4991V5.63135H75.5207V12.908L81.558 5.63135H85.4825L78.9908 13.4745Z",
    fill: "#38369C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M97.1027 21.2647L94.0516 16.4844C93.727 16.4844 93.3729 16.4844 92.9834 16.4844H90.7054V21.2647H87.4124V5.63146H94.7952C95.4894 5.62685 96.1773 5.76306 96.8174 6.03187C97.4575 6.30067 98.0364 6.69648 98.5191 7.19538C98.9981 7.69519 99.3803 8.27949 99.6463 8.91863C99.9198 9.58921 100.058 10.3072 100.054 11.0314C100.084 11.9568 99.8356 12.87 99.3394 13.6517C98.8396 14.3962 98.1929 15.0308 97.4391 15.5166L101.24 21.2647H97.1027ZM90.7054 13.5927H92.4228H93.7447C94.0856 13.5989 94.4265 13.5851 94.7657 13.5514C95.0466 13.522 95.3183 13.4351 95.5641 13.296C95.8098 13.1569 96.0242 12.9686 96.1939 12.7429C96.577 12.2341 96.7729 11.6088 96.7486 10.9724C96.7832 10.3635 96.5849 9.76434 96.1939 9.29634C95.8226 8.88593 95.3153 8.62387 94.7657 8.55864C94.5237 8.55864 94.1756 8.51733 93.727 8.51143C93.2785 8.50553 92.8241 8.51143 92.3756 8.51143H90.6818L90.7054 13.5927Z",
    fill: "#38369C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M114.613 18.3787V21.2646H103.122V5.63135H114.613V8.51131H106.415V12.0109H112.465V14.8319H106.415V18.3728H114.613V18.3787Z",
    fill: "#38369C"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M123.424 5.56634C124.394 5.67175 125.336 5.95588 126.203 6.40436C127.048 6.83474 127.806 7.41688 128.44 8.12172C129.08 8.83364 129.589 9.6527 129.945 10.5414C130.314 11.4607 130.502 12.4425 130.5 13.4331C130.508 14.4111 130.325 15.3812 129.963 16.2895C129.621 17.1593 129.123 17.9593 128.493 18.6501C127.856 19.3475 127.101 19.9269 126.262 20.3616C125.374 20.8216 124.414 21.1269 123.424 21.2645C122.85 21.3389 122.273 21.3803 121.695 21.3884C121.028 21.3884 120.379 21.3884 119.753 21.3884C119.027 21.3884 118.283 21.3294 117.522 21.2881V5.58995C118.313 5.54863 119.086 5.51913 119.836 5.50732C120.473 5.50732 121.128 5.50732 121.789 5.50732C122.45 5.50732 122.993 5.52503 123.424 5.56634ZM123.424 18.0836C123.937 18.0005 124.429 17.8159 124.87 17.5406C125.311 17.2663 125.697 16.912 126.009 16.496C126.327 16.0663 126.577 15.5907 126.752 15.0856C126.932 14.5573 127.024 14.003 127.024 13.4449C127.026 12.8953 126.93 12.3498 126.74 11.8338C126.559 11.3312 126.298 10.861 125.967 10.441C125.635 10.0362 125.236 9.69092 124.787 9.42006C124.361 9.15502 123.888 8.97281 123.394 8.88302C123.153 8.83924 122.908 8.81556 122.662 8.8122C122.373 8.8122 122.072 8.8122 121.807 8.8122C121.541 8.8122 121.158 8.84761 120.821 8.87122V18.0836C121.116 18.1131 121.411 18.1308 121.724 18.1485C122.037 18.1662 122.267 18.1485 122.562 18.1485C122.846 18.1447 123.13 18.123 123.412 18.0836H123.424Z",
    fill: "#38369C"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6498 27.8391H28.0249C29.5298 27.8391 30.3855 28.5296 30.3855 29.7925C30.3855 31.0555 29.5416 31.7519 28.0249 31.7519H27.4997V33.2981H26.6498V27.8391ZM27.9895 31.0024C29.0636 31.0024 29.5003 30.6247 29.5003 29.822C29.5003 29.0194 29.0577 28.6417 27.9895 28.6417H27.4997V31.0024H27.9895Z",
    fill: "#FF9700"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M34.6818 30.5713C34.6783 30.014 34.8403 29.4683 35.1472 29.0031C35.4542 28.538 35.8922 28.1744 36.4059 27.9585C36.9197 27.7425 37.4859 27.6839 38.033 27.7901C38.58 27.8962 39.0833 28.1623 39.479 28.5547C39.8747 28.9471 40.145 29.4481 40.2558 29.9942C40.3665 30.5404 40.3126 31.1071 40.101 31.6226C39.8894 32.1381 39.5295 32.5792 39.067 32.8901C38.6044 33.2009 38.0601 33.3674 37.5028 33.3686C37.1319 33.3774 36.7631 33.3112 36.4185 33.1741C36.0738 33.0369 35.7604 32.8315 35.4969 32.5703C35.2335 32.3091 35.0256 31.9974 34.8855 31.6539C34.7455 31.3104 34.6762 30.9422 34.6818 30.5713ZM39.4444 30.5713C39.4271 30.1901 39.2981 29.8224 39.0736 29.5139C38.8491 29.2053 38.5389 28.9696 38.1815 28.8358C37.8241 28.7021 37.4353 28.6763 37.0634 28.7616C36.6915 28.8469 36.3528 29.0396 36.0895 29.3158C35.8262 29.5919 35.6498 29.9393 35.5822 30.3149C35.5146 30.6904 35.5588 31.0775 35.7094 31.4282C35.8599 31.7788 36.1101 32.0775 36.429 32.2871C36.7478 32.4967 37.1212 32.6081 37.5028 32.6073C37.7669 32.6101 38.0288 32.5587 38.2722 32.4562C38.5156 32.3538 38.7354 32.2024 38.918 32.0115C39.1006 31.8207 39.242 31.5944 39.3336 31.3466C39.4251 31.0989 39.4649 30.835 39.4503 30.5713H39.4444Z",
    fill: "#FF9700"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M44.201 27.8389H45.0922L46.06 30.7484C46.1604 31.0494 46.2666 31.5274 46.2666 31.5274C46.2666 31.5274 46.4023 31.0612 46.5322 30.7484L47.8364 27.7976L49.1466 30.7484C49.2476 31.003 49.3343 31.2631 49.4062 31.5274C49.4062 31.5274 49.5184 31.0494 49.6187 30.7484L50.5865 27.8389H51.4128L49.5243 33.3569H49.418L48.0666 30.1169C47.9544 29.8514 47.8364 29.45 47.8364 29.45C47.8364 29.45 47.7125 29.8514 47.6004 30.1169L46.2076 33.3687H46.1073L44.201 27.8389Z",
    fill: "#FF9700"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M55.8272 27.8391H59.2914V28.5886H56.677V30.306H58.8488V31.0319H56.677V32.5545H59.4036V33.2981H55.8272V27.8391Z",
    fill: "#FF9700"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M68.014 33.2981H67.0343L66.0724 31.6987H64.892V33.2981H64.0363V27.8391H65.4173C66.9222 27.8391 67.7779 28.5296 67.7779 29.7807C67.7979 30.1144 67.7211 30.4467 67.5567 30.7378C67.3924 31.0288 67.1474 31.2662 66.8514 31.4214L68.014 33.2981ZM65.4173 30.9728C66.5032 30.9728 66.934 30.5892 66.934 29.7925C66.934 28.9958 66.4855 28.6122 65.4173 28.6122H64.9393V30.9728H65.4173Z",
    fill: "#FF9700"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M79.044 28.5886H77.6099V27.8391H81.3515V28.5886H79.9174V33.3099H79.0735L79.044 28.5886Z",
    fill: "#FF9700"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M85.3823 30.5713C85.3788 30.014 85.5407 29.4683 85.8477 29.0031C86.1546 28.538 86.5927 28.1744 87.1064 27.9585C87.6201 27.7425 88.1863 27.6839 88.7334 27.7901C89.2805 27.8962 89.7837 28.1623 90.1794 28.5547C90.5751 28.9471 90.8455 29.4481 90.9562 29.9942C91.0669 30.5404 91.0131 31.1071 90.8014 31.6226C90.5898 32.1381 90.2299 32.5792 89.7674 32.8901C89.3049 33.2009 88.7605 33.3674 88.2032 33.3686C87.8324 33.3774 87.4636 33.3112 87.1189 33.1741C86.7742 33.0369 86.4608 32.8315 86.1974 32.5703C85.934 32.3091 85.726 31.9974 85.5859 31.6539C85.4459 31.3104 85.3766 30.9422 85.3823 30.5713ZM90.1448 30.5713C90.1275 30.1901 89.9986 29.8224 89.774 29.5139C89.5495 29.2053 89.2393 28.9696 88.8819 28.8358C88.5246 28.7021 88.1358 28.6763 87.7639 28.7616C87.3919 28.8469 87.0533 29.0396 86.7899 29.3158C86.5266 29.5919 86.3502 29.9393 86.2826 30.3149C86.215 30.6904 86.2593 31.0775 86.4098 31.4282C86.5604 31.7788 86.8106 32.0775 87.1294 32.2871C87.4483 32.4967 87.8217 32.6081 88.2032 32.6073C88.4668 32.6093 88.7281 32.5573 88.9708 32.4545C89.2135 32.3516 89.4326 32.2002 89.6145 32.0094C89.7965 31.8186 89.9374 31.5926 90.0286 31.3452C90.1198 31.0979 90.1594 30.8345 90.1448 30.5713Z",
    fill: "#FF9700"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M102.627 31.2972L100.555 27.833H101.494L102.727 30.1169C102.827 30.2966 102.937 30.47 103.057 30.6363C103.183 30.4734 103.294 30.2996 103.388 30.1169L104.568 27.8684H105.442L103.459 31.2854V33.3274H102.609L102.627 31.2972Z",
    fill: "#FF9700"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M109.449 30.5713C109.449 28.9425 110.564 27.7681 111.957 27.7681C113.35 27.7681 114.459 28.9484 114.459 30.5713C114.459 32.1942 113.344 33.3687 111.957 33.3687C110.57 33.3687 109.449 32.2001 109.449 30.5713ZM113.686 30.5713C113.686 29.391 112.972 28.5294 111.957 28.5294C110.942 28.5294 110.222 29.4087 110.222 30.5713C110.222 31.7339 110.942 32.6074 111.957 32.6074C112.972 32.6074 113.686 31.7339 113.686 30.5713Z",
    fill: "#FF9700"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M118.88 31.3801V27.8391H119.712V31.3328C119.734 31.6689 119.883 31.984 120.129 32.2141C120.375 32.4442 120.7 32.5722 121.037 32.5722C121.373 32.5722 121.698 32.4442 121.944 32.2141C122.19 31.984 122.339 31.6689 122.362 31.3328V27.8391H123.253V31.3801C123.253 32.7079 122.261 33.3689 121.081 33.3689C119.901 33.3689 118.88 32.7079 118.88 31.3801Z",
    fill: "#FF9700"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0258 11.5152L5.52818 3.86084L5.52228 6.30999L12.0258 14.0174V11.5152Z",
    fill: "url(#paint0_linear_1741_204)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0258 16.0774V14.0178L5.52226 6.3103L5.51636 8.32864L12.0258 16.0774Z",
    fill: "url(#paint1_linear_1741_204)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M0.694814 3.26501V20.7396C1.51988 21.1876 2.48612 21.2997 3.39183 21.0523C4.81411 20.6746 5.66984 19.5947 5.66984 18.6917V1.61257C5.66984 1.02242 5.5164 0.762746 4.96165 0.644715C3.97342 0.561448 2.98889 0.842743 2.19381 1.43553C1.53703 1.80881 1.02081 2.38722 0.724322 3.08206C0.702647 3.14054 0.692623 3.20269 0.694814 3.26501Z",
    fill: "url(#paint2_linear_1741_204)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9018 7.69125V26.234C12.728 26.6785 13.6928 26.7904 14.5988 26.5468C16.0211 26.1691 16.8768 25.0891 16.8768 24.1861V6.14504C16.8768 5.55489 16.7234 5.29522 16.1686 5.17719C15.1804 5.09392 14.1959 5.37521 13.4008 5.968C12.7061 6.33837 12.1724 6.95194 11.9018 7.69125Z",
    fill: "url(#paint3_linear_1741_204)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4008 5.96788C12.6972 6.34967 12.1623 6.98141 11.9018 7.73835V26.2339C12.7012 26.6669 13.6332 26.7868 14.5162 26.5703V5.40723C14.1253 5.5534 13.7513 5.74138 13.4008 5.96788Z",
    fill: "url(#paint4_linear_1741_204)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M2.19372 1.43548C1.5408 1.8064 1.02688 2.38041 0.730134 3.07021C0.706103 3.1364 0.694111 3.20636 0.694725 3.27677V20.7395C1.47586 21.1624 2.38431 21.2862 3.2501 21.0877V0.898438C2.88045 1.04066 2.52645 1.22062 2.19372 1.43548Z",
    fill: "url(#paint5_linear_1741_204)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9654 17.4759V20.1906C16.7462 20.5339 16.4515 20.8225 16.1038 21.0345C15.5699 21.3687 14.9496 21.5385 14.32 21.5228C13.6904 21.507 13.0793 21.3065 12.5628 20.946C11.5536 20.2083 9.61202 17.9952 5.48092 13.0792C1.73933 8.55862 0.730161 7.19536 0.5 6.87077V4.99407C0.5 4.15015 0.694752 4.15015 0.694752 4.15015V4.20916C0.694752 4.32719 2.46522 6.56979 5.26257 9.9809C8.05991 13.392 9.98382 15.5579 11.0579 16.7559C12.132 17.9539 13.0408 18.668 14.1916 18.7742C14.63 18.8198 15.0729 18.76 15.4835 18.5999C15.8941 18.4398 16.2605 18.1839 16.5523 17.8536C16.6691 17.7091 16.7738 17.5551 16.8651 17.3933V17.3106C16.9064 17.2988 16.9654 17.352 16.9654 17.4759Z",
    fill: "url(#paint6_linear_1741_204)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M5.26847 14.7731C7.41074 17.3993 8.45532 18.6209 10.8809 21.2648C12.1733 22.6871 12.9523 23.0352 14.3038 23.1179C14.7917 23.1413 15.2784 23.0505 15.7251 22.8528C16.1718 22.655 16.5661 22.3558 16.8769 21.9789C16.8769 21.9789 16.9654 21.9258 16.9654 21.731V20.1907C16.7462 20.534 16.4515 20.8226 16.1038 21.0346C15.5704 21.3703 14.9499 21.541 14.3199 21.5252C13.6899 21.5095 13.0787 21.308 12.5628 20.9461C11.5536 20.2084 9.61202 17.9953 5.48092 13.0793C1.73933 8.5528 0.730161 7.19544 0.5 6.87085V8.87148C0.500664 8.90512 0.510899 8.93788 0.529508 8.96591C0.741964 9.21967 2.0167 10.819 5.26847 14.7731Z",
    fill: "url(#paint7_linear_1741_204)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1741_204",
    x1: -3.56024,
    y1: 10.0634,
    x2: 17.1248,
    y2: 8.18079,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#FFEAA9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#FFD348"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#FF9B1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1741_204",
    x1: 1.26723,
    y1: -3.16762,
    x2: 9.51172,
    y2: 12.6014,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#FFEAA9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#FFD348"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#FF9B1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1741_204",
    x1: 2.08168,
    y1: 10.8544,
    x2: 5.71115,
    y2: 10.9548,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#FFA200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#FF8E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#FF5B00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1741_204",
    x1: 12.4742,
    y1: 15.9771,
    x2: 17.3135,
    y2: 15.8295,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#FFA200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#FF9200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#FF6800"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#FF4A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1741_204",
    x1: 8.63823,
    y1: 9.42029,
    x2: 16.8473,
    y2: 20.9166,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#FFB816"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#FFA200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FF8D00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#FF7000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#FF5B00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#FF4E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#FF4A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F03B00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1741_204",
    x1: 1.96946,
    y1: 25.1893,
    x2: 1.96946,
    y2: 1.1345,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA200"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#FFA000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#FF7B00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#FF6000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#FF5000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1741_204",
    x1: 0.0219725,
    y1: 36.4081,
    x2: 13.3831,
    y2: -0.482586,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#FFD348"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#FF4A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#FFD348"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#FF9B1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1741_204",
    x1: -1.23506,
    y1: -0.671356,
    x2: 16.8887,
    y2: 27.0011,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEAA9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FF4A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#FFD348"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#FF9B1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#FF4A00"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNeokredLogo);
export default __webpack_public_path__ + "static/media/Neokred_Logo.8871934760aec933b2719f87043cb5bf.svg";
export { ForwardRef as ReactComponent };